import ModalWrapper from '../../common/Modal/ModalWrapper'
import { toggleModal } from '../../../reducers/modalReducer';
import Button from '../../common/Button';
import { postRequest, showMessage } from '../../../config';
import { setCompany } from '../../../reducers/companyReducer';

const FirstSetupDataRepositoryModal = ({ modalType, dispatch, companyId, company }) => {

    const handleVisitedDataRepo = async () => {
        try {
            dispatch(toggleModal({ open: '' }))
            dispatch(setCompany({ ...company, firstVisitRepository: true }))
            const res = await postRequest('/company/updateFirstVisitDataRepo', { companyId })
        } catch (err) {
            showMessage(err.message)
        }
    }

    return (
        <ModalWrapper
            modalType={modalType}
            modalCardClasses={"maw1000px FirstSetupData bg38"}
            onCloseHandler={handleVisitedDataRepo}
        >

            <div className="df fdc">
                <p className="c15 fs1-25rem fw400">First time?</p>
                <h1 className="c15 fs1-5rem fw600 mb2rem">3 Ways to populate our Data Repository</h1>
            </div>
            <div className="w100 dg gtcr3 gg1rem">
                <img
                    className='w100'
                    src={require('../../../../images/landingpage/first-time-repository-1.png')}
                    alt='first-time-repository'
                />
                <img
                    className='w100'
                    src={require('../../../../images/landingpage/first-time-repository-2.png')}
                    alt='first-time-repository-1'
                />
                <img
                    className='w100'
                    src={require('../../../../images/landingpage/first-time-repository-3.png')}
                    alt='first-time-repository-3'
                />
            </div>

            <div
                className='mt2rem w100 fs1rem df jcc'
            >
                <Button
                    btnType="warning"
                    customClassName="w40 cp"
                    text={"Let’s Go!"}
                    onClick={handleVisitedDataRepo}
                />
            </div>

        </ModalWrapper>
    )
}

export default FirstSetupDataRepositoryModal